import { Alert } from "antd";
import { TournamentTableDto } from "../../types/stats";
import { FCRodinaTable } from "../Table";
import { TableTeamTitle } from "../Table/TeamTitle";
import { getStaticUrl } from "../../utils";

interface TournamentTableProps {
    data: TournamentTableDto;
    title?: string;
    extra?: Record<number, string>;
}

export const TournamentTable: React.FC<TournamentTableProps> = ({ data, title, extra }) => {
    const dataColumns = [
        { title: '#', dataIndex: 'position', key: 'position' },
        { title: 'Команда', dataIndex: 'teamName', key: 'teamName', left: true },
        { title: 'И', dataIndex: 'matchesPlayed', key: 'matchesPlayed' },
        { title: 'В', dataIndex: 'wins', key: 'wins' },
        { title: 'Н', dataIndex: 'draws', key: 'draws' },
        { title: 'П', dataIndex: 'losses', key: 'losses' },
        { title: 'ГЗ', dataIndex: 'goalsFor', key: 'goalsFor' },
        { title: 'ГП', dataIndex: 'goalsAgainst', key: 'goalsAgainst' },
        { title: 'О', dataIndex: 'points', key: 'points' }
    ];

    const smallColumns = [
        { title: '#', dataIndex: 'position', key: 'position' },
        { title: 'Команда', dataIndex: 'teamName', key: 'teamName', left: true },
        { title: 'О', dataIndex: 'points', key: 'points' },
        { title: 'В', dataIndex: 'wins', key: 'wins' },
        { title: 'Н', dataIndex: 'draws', key: 'draws' },
        { title: 'П', dataIndex: 'losses', key: 'losses' },
        { title: 'РМ', dataIndex: 'goalsDiff', key: 'goalsDiff' },
    ];


    let highlightRows: Set<number> = new Set();

    let extraCount = 0;
    const dataItems = data.map((item, index) => {
        if ([3, 135, 204, 724].includes(item.teamId)) {
            highlightRows.add(index)
        }
        const result = dataColumns.map((column) => {
            const value = item[column.dataIndex];
            if (column.dataIndex === 'teamName') {
                return {
                    key: column.key,
                    value: (
                        <TableTeamTitle logoUrl={getStaticUrl(item.teamLogo)} name={value} />
                    )
                }
            }
            if (column.dataIndex === 'points' && extra?.[item.position]) {
                extraCount++;
                let val = value + ' ';
                for (let i = 0; i < extraCount; i++) {
                    val += '*';
                }
                return {
                    key: column.key,
                    value: val
                }
            }
            return {
                key: column.key,
                value
            }
        });

        result.push({
            key: 'goalsDiff',
            value: item.goalsFor - item.goalsAgainst,
        });

        return result;
    });

    let extraText = [];

    if (extra) {
        extraText = Object.values(extra).map((value, index) => {
            let text = '';
            for (let i = 0; i < index + 1; i++) {
                text += '*';
            }
            return <p key={index}>{text + ' - ' + value}</p>;
        });
    }

    return (
        <div className="w-full">
            {title && <div className="w-full text-sky-900 text-left font-medium pb-4">{title}</div>}
            <div className="hidden sm:block">
                <FCRodinaTable
                    columns={dataColumns}
                    data={dataItems}
                    highlightRows={highlightRows}
                    rowClass="text-sm sm:text-2xl"
                />
            </div>
            <div className="sm:hidden">
                <FCRodinaTable
                    columns={smallColumns}
                    data={dataItems}
                    highlightRows={highlightRows}
                    rowClass="text-sm sm:text-2xl"
                />
            </div>
            {extraText?.length > 0 && <div className="w-full py-4">
                <Alert message={extraText} type="info" />
            </div >}
        </div>
    );
}

